class ReportsController implements ng.IComponentController {
    constructor() {
        'ngInject';
    }
}

export const reportsComponent: ng.IComponentOptions = {
    controller: ReportsController,
    template: '<ui-view name="main"></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/reports.component.ts